export var DICE_VOD_ANNOTATIONS_PLUGIN_ID="@dicetechnology/doris-plugin-dice-vod-annotations";